import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface AlertModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function AlertModal ({ isOpen, onClose }: AlertModalProps) {

  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      navigate("./#thanks");
    } else {
      document.body.style.overflow = 'unset';
      navigate("./");
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 overflow-y-auto pt-8 pb-8">
      <div className="bg-white rounded-xl max-w-2xl w-full relative p-8">
        <label className="block text-xl font-bold text-gray-700 mb-2">
          お問合せ完了
        </label>
        <label className="text-gray-600">
          お問合せを受け付けました。
        </label>
        <div className="pt-5">
          <button className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#eb4b3f] to-[#f0945b] text-white text-base font-semibold rounded-full hover:from-[#d43d31] hover:to-[#e08549] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
    </>
  );
}